import { CurrencyAmount, FIAT_CURRENCY } from "@orb-labs/types";
export const ONE_TRILLION = BigInt(1_000_000_000_000);
export const ONE_BILLION = BigInt(1_000_000_000);
export const ONE_MILLION = BigInt(1_000_000);
export const ONE_THOUSAND = BigInt(1_000);
export const ONE_USD_RAW = BigInt(1) * BigInt(10 ** FIAT_CURRENCY.decimals);
export const ONE_THOUSAND_RAW = ONE_THOUSAND * BigInt(10 ** FIAT_CURRENCY.decimals);
export const ONE_MILLION_RAW = ONE_MILLION * BigInt(10 ** FIAT_CURRENCY.decimals);
export const ONE_BILLION_RAW = ONE_BILLION * BigInt(10 ** FIAT_CURRENCY.decimals);
export const ONE_TRILLION_RAW = ONE_TRILLION * BigInt(10 ** FIAT_CURRENCY.decimals);
export const ZERO_CURRENCY_AMOUNT = CurrencyAmount.fromRawAmount(FIAT_CURRENCY, BigInt(0));
export const ONE_BILLION_CURRENCY_AMOUNT = CurrencyAmount.fromRawAmount(FIAT_CURRENCY, ONE_BILLION_RAW);
export const ONE_MILLION_CURRENCY_AMOUNT = CurrencyAmount.fromRawAmount(FIAT_CURRENCY, ONE_MILLION_RAW);
export const getOnrampOperationKey = (platformId, operationData) => {
    const data = JSON.parse(operationData);
    return {
        key: `${platformId}-${data.partnerUserRef}`,
        partnerUserRef: data.partnerUserRef,
    };
};
export const getExternalOperationKey = (platformId, operationData) => `${platformId}-${operationData}`;
/** Green — positive change, profit, up, buy. */
export const COLOR_POSITIVE = "#00C805";
/** Red — negative change, loss, down, sell. */
export const COLOR_NEGATIVE = "#F44336";
export const COLOR_NO = "#EB5D2A";
/** Gray — neutral, no change, flat. */
export const COLOR_NEUTRAL = "#666666";
